var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H26V28H22V14ZM22 30H26V34H22V30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 14H26V28H22V14ZM22 30H26V34H22V30Z",
    fill: "#F46A6A",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.414 14.586L33.414 4.586C33.04 4.21 32.532 4 32 4H16C15.468 4 14.96 4.21 14.586 4.586L4.586 14.586C4.21 14.96 4 15.468 4 16V32C4 32.532 4.21 33.04 4.586 33.414L14.586 43.414C14.96 43.79 15.468 44 16 44H32C32.532 44 33.04 43.79 33.414 43.414L43.414 33.414C43.79 33.04 44 32.532 44 32V16C44 15.468 43.79 14.96 43.414 14.586ZM40 31.172L31.172 40H16.828L8 31.172V16.828L16.828 8H31.172L40 16.828V31.172Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.414 14.586L33.414 4.586C33.04 4.21 32.532 4 32 4H16C15.468 4 14.96 4.21 14.586 4.586L4.586 14.586C4.21 14.96 4 15.468 4 16V32C4 32.532 4.21 33.04 4.586 33.414L14.586 43.414C14.96 43.79 15.468 44 16 44H32C32.532 44 33.04 43.79 33.414 43.414L43.414 33.414C43.79 33.04 44 32.532 44 32V16C44 15.468 43.79 14.96 43.414 14.586ZM40 31.172L31.172 40H16.828L8 31.172V16.828L16.828 8H31.172L40 16.828V31.172Z",
    fill: "#F46A6A",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerError);
export default __webpack_public_path__ + "static/media/danger-error.aae17fe93e544ff488f37ed76ac1763d.svg";
export { ForwardRef as ReactComponent };